import { render, staticRenderFns } from "./403.vue?vue&type=template&id=b87144bc&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87144bc",
  null
  
)

export default component.exports